import { ListConductorFilters } from '../../list-conductor/filters';
import { NUMBER_OPERATORS, STRING_OPERATORS } from '../constants';
import { ChipLabelFilterType, Filter } from '../interface';

export const FilterChipsFactory = (filters: ListConductorFilters, filtersMetaData: Filter[]) => {
  const FilterMetaObj: Record<string, Filter> = {};

  filtersMetaData.forEach((metaData: Filter) => {
    FilterMetaObj[metaData.filterKey] = metaData;
  });

  let chipsData: ChipLabelFilterType[] = [];
  chipsData = filters.map(filter => ({
    icon: FilterMetaObj[filter.filter]?.icon,
    filterType: FilterMetaObj[filter.filter].filterType,
    filter: filter.filter,
    title: FilterMetaObj[filter.filter]?.title,
    value: filter.value,
    ...getOperatorLabel(filter.operator)
  }));

  return chipsData;
};

export const getOperatorLabel = (operator: string) => {
  if (operator === 'RANGE') {
    return { operator };
  }

  const operatorFound = [...NUMBER_OPERATORS, ...STRING_OPERATORS].filter(
    _operatorObj => operator === _operatorObj.value
  );

  if (operatorFound.length) {
    return { operator: operatorFound[0].label };
  }
  return {};
};

export const getFlatFiltersData = (chips: ChipLabelFilterType[]) => {
  const flatFilters: ChipLabelFilterType[] = chips.flatMap(filter => {
    if (Array.isArray(filter.value) && filter.operator !== 'RANGE') {
      return filter.value.map(value => ({ ...filter, value }));
    }
    return [filter];
  });
  return flatFilters;
};
